module.exports = __webpack_public_path__ + "img/four-trillion.2620237b.svg";